import Vue from 'vue';
import VueForm from './frontend/Form.vue';

(function() {
    document.addEventListener('DOMContentLoaded', () => {
        if(document.querySelector('.vue-form')) {

            const app = new Vue({
                el: '.vue-form',
                components: {
                    VueForm
                },
                props: {
                    structure: {
                        type: Object
                    },
                    formId: {
                        type: Number
                    }
                }
            });
        }
    });
})();